exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addbtn {\n  min-width: 60px;\n  max-width: 60px;\n  min-height: 34px;\n  max-height: 34px;\n  margin-left: 3px;\n\n}\n\nh1 {\n  font-family: 'Roboto', sans-serif;\n  font-size: 30px;\n  font-weight: 300;\n}\n\n.row.title {\n  margin-top: 20px;\n}\n\n.row.search {\n  margin-top: 30px;\n  padding-bottom: 15px;\n}\n\n.row.content {\n  padding:15px;\n}\n\n.row.content > [class*='col-'] > button {\n  margin-top: 30px;\n  margin-bottom: 10px;\n}\n\ninput[type=text] {\n  min-height: 34px;\n  width: 100%;\n}\n\ninput[type=text]:-moz-read-only {\n  background-color: #aaaaaa;\n}\n\ninput[type=text]:read-only {\n  background-color: #aaaaaa;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/Jose.Soto/Documents/Websites/SecretSanta/src/app/profile-wish-list/profile-wish-list.component.css
// module id = ../../../../../src/app/profile-wish-list/profile-wish-list.component.css
// module chunks = main